import { getI18nFromGeneral } from 'src/tools/tools';
import { handleError } from 'src/constrains/SalesChannelContent-Revamp/ModuleList/validator';
import { get } from 'lodash';
import { randomNumber } from 'src/tools/helper';
import { generateNoneLinkData } from 'src/constrains/LinkLibrary/tools';

const generateDefaultLinkTo = (salesChannelUuid: string) => ({
  ...generateNoneLinkData(),
  salesChannelUuid,
});

const checkBackgroundStyle = (image) => {
  const uuid = get(image, 'uuid');
  if (!uuid) {
    return handleError([
      getI18nFromGeneral(`general.moduleListError.${199221}`),
    ]);
  }
};

const checkEachPolicy = () => {
  const checkTitle = (title) => {
    if (!title) {
      return handleError([
        getI18nFromGeneral(`general.moduleListError.${999993}`),
      ]);
    }
  };
  const checkLink = (linkTo) => {
    const linkType = get(linkTo, 'linkType');
    if (!linkType) {
      return handleError([
        getI18nFromGeneral(`general.moduleListError.${104316}`),
      ]);
    }
  };
  const checkAll = (policy) => {
    const title = get(policy, 'title');
    const linkTo = get(policy, 'linkTo');
    const iLink = checkLink(linkTo);
    const iTitle = checkTitle(title);
    return {
      hasError: get(iTitle, 'hasError') || get(iLink, 'hasError'),
    };
  };
  return { checkAll, checkLink, checkTitle };
};

const checkPolicy = (data) => {
  const items = get(data, 'policy.items') || [];
  let flag = false;
  const { checkAll } = checkEachPolicy();
  items.forEach((item) => {
    const res = checkAll(item);
    const hasError = get(res, 'hasError');
    if (!flag && hasError) {
      flag = true;
    }
  });
  return { hasError: flag };
};

const checkAll = (data) => {
  console.log(data, 'data');

  const image = get(data, 'backgroundStyle.image');
  console.log(checkBackgroundStyle(image), 'immmmm');
  console.log(checkPolicy(data), 'asdsadsads');
  return {
    hasError:
      get(checkBackgroundStyle(image), 'hasError') ||
      get(checkPolicy(data), 'hasError'),
  };
};

const generateBackgroundStyle = () => {
  return {
    backgroundStyle: {
      image: null,
      primaryColor: '#000',
      textColor: '#000',
      tabColor: '#000',
    },
  };
};
const generatePolicy = (salesChannelUuid: string) => {
  return {
    policy: {
      items: [
        {
          draggableId: `policy_${randomNumber()}`,
          title: 'Policy 1',
          linkTo: generateDefaultLinkTo(salesChannelUuid),
        },
      ],
    },
  };
};
const generateProfileContentManagement = () => {
  return {};
};
export {
  checkBackgroundStyle,
  checkEachPolicy,
  checkPolicy,
  generateBackgroundStyle,
  generateDefaultLinkTo,
  generatePolicy,
  generateProfileContentManagement,
  checkAll,
};
